import { render } from "./WDatePicker.vue?vue&type=template&id=60a41c36&ts=true"
import script from "./WDatePicker.vue?vue&type=script&lang=ts"
export * from "./WDatePicker.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__